import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getGrantItemsForSpecialHolidayGrantHistory,
  downloadSpecialHolidayGrantHistoryCsv,
} from 'api/holidayManagement';
import SpecialHolidayGrantHistoryDomain from 'domain/master/holidayManagement/specialHolidayGrantHistory';
import { HolidayManagementContext } from './../../HolidayManagementForm'

export const useSpecialHolidayGrantHistoryDomainForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [paidHolidayGrantHistoryList, setPaidHolidayGrantHistoryList] = useState<
  Array<SpecialHolidayGrantHistoryDomain>
  >([]);
  const [noManager, setNoManager] = useState(false);
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const yearCurrent = new Date().getFullYear().toString();
  const [targetDateFrom, setTargetDateFrom] = useState<Date>(new Date(`${yearCurrent}/01/01`));
  const [targetDateTo, setTargetDateTo] = useState<Date>(new Date(`${yearCurrent}/12/31`));
  const [modalOpen, setModalOpen] = useState(false);

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    const response = await getGrantItemsForSpecialHolidayGrantHistory(
      orgCode !== 'all' ? orgCode : '',
      targetDateFrom,
      targetDateTo,
    );
    setPaidHolidayGrantHistoryList(
      response.map((result) => new SpecialHolidayGrantHistoryDomain(result)),
    );
    contextObject.setIsLoading(false);
  }, [orgCode, targetDateFrom, targetDateTo]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgCode, targetDateFrom, targetDateTo]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return {
    paidHolidayGrantHistoryList,
    toggleNoManager,
    orgCode,
    setOrgCode,
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    modalOpen,
    setModalOpen,
    closeModal,
  };
};

export const useDownloadHolidayManagementSpecialHolidayGrantHistory = (
  orgCode: string,
  targetDateFrom: Date,
  targetDateTo: Date,
) => {
  const [blocking , setBlocking] = useState(false);
  const downloadHolidayManagementSpecialHolidayGrantHistory = useCallback((
    isDownloadAll?: boolean,
  ) => {
    setBlocking(true);
    downloadSpecialHolidayGrantHistoryCsv(
      isDownloadAll ? '' : orgCode,
      targetDateFrom,
      targetDateTo,
    ).then(() => {
      setBlocking(false);
    });
  }, [orgCode, targetDateFrom, targetDateTo]);

  return {
    blocking,
    downloadHolidayManagementSpecialHolidayGrantHistory
  };
};

export default {
  useSpecialHolidayGrantHistoryDomainForm,
};
